import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/**
 * integrations: W — ulanishlar (barcha hamkorlar + platforma), Telegram, webhook jurnali, MoySklad zaxira;
 * S — hamkor o'z marketplace do'konlarini ulaydi, holat/tarix va listinglarni boshqaradi.
 */
export const workRoutes: RouteObject[] = [
  { path: 'integrations', ...page(() => import('./pages/ConnectionsPage')) },
  { path: 'integrations/telegram', ...page(() => import('./pages/TelegramPage')) },
  { path: 'integrations/webhooks', ...page(() => import('./pages/WebhooksPage')) },
  { path: 'integrations/mirror', ...page(() => import('./pages/MirrorPage')) },
  { path: 'integrations/:id', ...page(() => import('./pages/ConnectionDetailPage')) },
];

export const sellerRoutes: RouteObject[] = [
  { path: 'integrations', ...page(() => import('./pages/ConnectionsPage')) },
  { path: 'integrations/:id', ...page(() => import('./pages/ConnectionDetailPage')) },
];
